import AppHttp from '@/lib/AppHttp';
import Errors from '@/lib/Errors';
import { AxiosError } from 'axios';
import { ReportRefreshStatusViewModel } from '@/models/api';

class PowerBIService {
    public async getReportEmbedConfig(reportName: string) {
        const response = await AppHttp.get(`Reports/GetEmbedReport/${reportName}`);
        const data = response ? response.data : null;
        return data;
    }

    public async getReportRefreshStatus(): Promise<ReportRefreshStatusViewModel> {
        const response = await AppHttp.get(`Reports/Refresh`);
        const data = response ? response.data : null;
        return data;
    }

    public async triggerReportRefresh(): Promise<void> {
        const response = await AppHttp.post('Reports/Refresh', null);
        const data = response ? response.data : [];
        return data;
    }
}

export default new PowerBIService();